import React, { useMemo } from 'react'
import classNames from 'classnames'

import style from './style.module.css'
import { ProgrammingClassType } from 'pages/Programming/types'

type Props = {
  children: ProgrammingClassType
  className?: string
}

function Tag({ children, className }: Props) {
  const typeClassName = useMemo(() => {
    switch (children) {
      case ProgrammingClassType.Benchmark:
        return 'benchmark'
      case ProgrammingClassType.HeavyDay:
        return 'heavyDay'
      case ProgrammingClassType.Partner:
        return 'partner'
    }
  }, [children])

  return (
    <div className={classNames(style.wrapper, className, style[typeClassName])}>
      {children}
    </div>
  )
}

export default Tag
